import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { CONTENT } from "@/content";

const SECTIONS = [
  {
    title: "Éditrice du site",
    content: [
      `${CONTENT.name} — ${CONTENT.title}, infirmière diplômée d'État`,
      `Numéro Adeli : ${CONTENT.adeli}`,
      CONTENT.address,
      `Téléphone : ${CONTENT.phone}`,
      `Email : ${CONTENT.email}`,
    ],
  },
  {
    title: "Directrice de la publication",
    content: [`${CONTENT.name}, en qualité d'éditrice du site.`],
  },
  {
    title: "Hébergement",
    content: [
      "Ce site est hébergé par Emergent — emergent.sh.",
      "Les données sont hébergées au sein de l'infrastructure de l'hébergeur.",
    ],
  },
  {
    title: "Propriété intellectuelle",
    content: [
      "L'ensemble des contenus de ce site (textes, photographies, illustrations, logo, univers graphique Corps en Mouvement) est la propriété exclusive de Sabine Sissan, sauf mention contraire.",
      "Toute reproduction, représentation ou diffusion, totale ou partielle, sans autorisation écrite préalable est interdite.",
    ],
  },
  {
    title: "Données personnelles",
    content: [
      "Ce site ne collecte aucune donnée personnelle via des formulaires. La prise de rendez-vous s'effectue via la plateforme Doctolib, soumise à sa propre politique de confidentialité.",
      "Pour toute question relative à vos données, vous pouvez écrire à : " + CONTENT.email + ".",
    ],
  },
  {
    title: "Cookies",
    content: ["Ce site n'utilise pas de cookies de suivi ou de mesure d'audience."],
  },
  {
    title: "Information de santé",
    content: [
      "Les contenus de ce site et des ebooks Corps en Mouvement ont une visée pédagogique. Ils ne remplacent en aucun cas une consultation, un diagnostic ou un avis médical.",
    ],
  },
];

const MentionsLegales = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="grain min-h-screen bg-ivory" data-testid="mentions-legales-page">
      <header className="border-b border-beige/70 bg-ivory/90">
        <div className="mx-auto flex max-w-4xl items-center justify-between px-6 py-5">
          <Link to="/" className="flex items-center gap-3" data-testid="legal-logo-link">
            <img src="/logo-emblem.png" alt={`Logo ${CONTENT.name}`} className="h-10 w-auto" />
            <span>
              <span className="block font-serif text-lg tracking-wide text-anthracite">{CONTENT.name}</span>
              <span className="block text-[9px] uppercase tracking-[0.3em] text-taupe/80">{CONTENT.title}</span>
            </span>
          </Link>
          <Link
            to="/"
            data-testid="legal-back-link"
            className="flex items-center gap-2 text-xs font-medium uppercase tracking-[0.18em] text-taupe transition-colors hover:text-anthracite"
          >
            <ArrowLeft className="h-4 w-4" strokeWidth={1.2} />
            Retour au site
          </Link>
        </div>
      </header>

      <main className="mx-auto max-w-4xl px-6 py-16 md:py-24">
        <p className="text-xs font-medium uppercase tracking-[0.28em] text-gold">Informations légales</p>
        <h1 className="mt-4 font-serif text-4xl font-light tracking-tight text-anthracite md:text-5xl">
          Mentions légales
        </h1>
        <div className="gold-rule mt-8 w-24" />

        <div className="mt-14 space-y-12">
          {SECTIONS.map((s, i) => (
            <section key={s.title} data-testid={`legal-section-${i}`}>
              <h2 className="font-serif text-2xl font-light italic text-anthracite">{s.title}</h2>
              <div className="mt-4 space-y-2">
                {s.content.map((line, j) => (
                  <p key={j} className="text-sm font-light leading-relaxed text-taupe md:text-base">{line}</p>
                ))}
              </div>
            </section>
          ))}
        </div>

        <p className="mt-16 text-[11px] uppercase tracking-[0.2em] text-taupe/60">
          Dernière mise à jour : juillet 2026
        </p>
      </main>
    </div>
  );
};

export default MentionsLegales;
